import { useEffect, useState } from 'react';
import settingsApi from '../api/settingsApi';
import { SETTING_KEYS } from '../constants';

const AdminMetaTagsUpdater = () => {
  const [faviconUrl, setFaviconUrl] = useState(null);

  useEffect(() => {
    const fetchFavicon = async () => {
      try {
        const faviconResponse = await settingsApi.getSettingByKey(SETTING_KEYS.FAVICON);
        if (faviconResponse.success && faviconResponse.data && faviconResponse.data.value) {
          const url = faviconResponse.data.value;
          setFaviconUrl(url);
        } else {
          setFaviconUrl(null);
        }
      } catch (error) {
        console.error('AdminMetaTagsUpdater: Failed to load admin favicon:', error);
      }
    };

    fetchFavicon();
  }, []);

  useEffect(() => {
    const updateLinkTag = (rel, href, type = null) => {
      let tag = document.querySelector(`link[rel="${rel}"]`);
      if (!tag) {
        tag = document.createElement('link');
        tag.setAttribute('rel', rel);
        document.head.appendChild(tag);
      }
      tag.setAttribute('href', href); // Always update href
      if (type) {
        tag.setAttribute('type', type);
      } else {
        tag.removeAttribute('type');
      }
    };

    // Determine the correct MIME type based on the faviconUrl extension
    let faviconMimeType = 'image/x-icon'; // Default
    if (faviconUrl) {
      if (faviconUrl.endsWith('.png')) {
        faviconMimeType = 'image/png';
      } else if (faviconUrl.endsWith('.ico')) {
        faviconMimeType = 'image/x-icon';
      } else if (faviconUrl.endsWith('.svg')) {
        faviconMimeType = 'image/svg+xml';
      }
    }

    // Remove any existing favicon links to prevent duplicates or old favicons
    document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach(link => link.remove());

    if (faviconUrl) {
      updateLinkTag('icon', faviconUrl, faviconMimeType);
      updateLinkTag('shortcut icon', faviconUrl, faviconMimeType); // Often used for older browsers
    } else {
      // Fallback to a default favicon if none is provided or fetched
      updateLinkTag('icon', '/favicon.ico', 'image/x-icon');
      updateLinkTag('shortcut icon', '/favicon.ico', 'image/x-icon');
    }
  }, [faviconUrl]);

  return null;
};

export default AdminMetaTagsUpdater;